export default __webpack_public_path__ + "static/media/2B_360_2.597f5c01.jpg";